// "use strict";

// /**
//  * Toppage carousel
//  */

// import Swiper from "swiper";

// const swiperTop = new Swiper(".m-topHeroarea.swiper-container", {
//     loop: true,
//     autoplay: {
//         delay: 5000,
//         disableOnInteraction: false,
//     },
//     slidesPerGroup: 1,
//     speed: 800,
//     navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//     },
//     pagination: { el: ".swiper-pagination" },
// });
